import {ForwardedRef, forwardRef} from 'react';
import {twMerge} from '../../../common/twMerge';
import {Text} from '../../atoms/Text/Text';
import {PromotionBannerItemProps} from './PromotionBannerItemProps.interface';

function PromotionBannerItemInner(
  {
    bannerTitle,
    leftImageUrl,
    rightImageUrl,
    className,
    ...props
  }: PromotionBannerItemProps,
  ref: ForwardedRef<HTMLDivElement>
) {
  return (
    <div
      ref={ref}
      className={twMerge([
        'flex h-44pxr w-full cursor-pointer items-center rounded-8pxr bg-theme-solid-10',
        className,
      ])}
      {...props}
    >
      <img
        alt="좌측 이미지"
        src={leftImageUrl}
        className="ml-10pxr mr-4pxr h-32pxr w-32pxr"
      />
      <Text className="font-medium2-bold flex-1 text-theme-solid-100 line-clamp-1">
        {bannerTitle}
      </Text>
      <img
        alt="우측 이미지"
        src={rightImageUrl}
        className="mx-10pxr h-24pxr w-24pxr"
      />
    </div>
  );
}

export const PromotionBannerItem = forwardRef(PromotionBannerItemInner);
